var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ContentCategoryService } from "../../../services/contentCategory/contentCategory.service";
import { useQuery } from "react-query";
export var useAllContentCategories = function () {
    var _a;
    var query = useQuery('allContentCategories', function () {
        return ContentCategoryService.getAllContentCategories({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useContentCategories = function (categoryIds) {
    var _a;
    var idsSorted = __spreadArray([], categoryIds, true).sort(function (a, b) { return a.localeCompare(b); });
    var query = useQuery(['allContentCategories', idsSorted], function () {
        return ContentCategoryService.getAllContentCategories({
            id: idsSorted,
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
